import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Button from '../common/Button';
import Modal from '../common/Modal';

export default function LoginButton() {
  const { user, login, logout, isLoading } = useAuth();
  const [showConfirm, setShowConfirm] = useState(false);

  if (isLoading) return <div className="w-24 h-8 bg-gray-200 rounded animate-pulse" />;

  if (user) {
    return (
      <>
        <div className="flex items-center gap-2">
          <UserAvatar user={user} />
          <button
            onClick={() => setShowConfirm(true)}
            className="flex items-center gap-1 text-sm text-gray-500 hover:text-gray-800 px-1 py-1 rounded transition-colors"
            title="ログアウト"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2h6a2 2 0 012 2v1" />
            </svg>
            <span className="hidden sm:inline">ログアウト</span>
          </button>
        </div>

        <Modal isOpen={showConfirm} onClose={() => setShowConfirm(false)} title="ログアウト">
          <div className="space-y-4 text-sm text-gray-700">
            <p>ログアウトしますか？</p>
            <div className="flex gap-3 justify-end pt-1">
              <button
                onClick={() => setShowConfirm(false)}
                className="px-4 py-2 text-gray-500 hover:text-gray-700"
              >
                キャンセル
              </button>
              <button
                onClick={() => { setShowConfirm(false); logout(); }}
                className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 font-medium"
              >
                ログアウト
              </button>
            </div>
          </div>
        </Modal>
      </>
    );
  }

  return (
    <Button onClick={login} size="sm">
      <XIcon />
      Xでログイン
    </Button>
  );
}

function UserAvatar({ user }: { user: { x_avatar_url: string | null; x_display_name: string; is_pro: boolean; subscription_tier: string } }) {
  return (
    <Link to="/profile" className="flex items-center gap-2 hover:opacity-80 transition-opacity">
      {user.x_avatar_url ? (
        <img
          src={user.x_avatar_url}
          alt={user.x_display_name}
          className="w-8 h-8 rounded-full"
        />
      ) : (
        <div className="w-8 h-8 rounded-full bg-gray-300 flex items-center justify-center text-xs font-bold">
          {user.x_display_name[0]}
        </div>
      )}
      <span className="hidden sm:inline text-sm font-medium">{user.x_display_name}</span>
      {user.is_pro && <CertifiedBadge />}
    </Link>
  );
}

/** サブスクリプション加入者バッジ（黄色 PRO） */
export function ProBadge() {
  return (
    <span className="inline-flex items-center px-1.5 py-0.5 text-xs font-bold bg-yellow-400 text-yellow-900 rounded">
      PRO
    </span>
  );
}

/** 公認雀士バッジ */
export function CertifiedBadge() {
  return (
    <span className="inline-flex items-center px-1.5 py-0.5 text-xs font-bold bg-blue-100 text-blue-700 rounded border border-blue-300">
      公認雀士
    </span>
  );
}

function XIcon() {
  return (
    <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.747l7.73-8.835L1.254 2.25H8.08l4.26 5.631 5.904-5.631zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
  );
}
